<template>
    <div class="tc-context-helper">
        <SVGDND/>
        <div class="tc-context-helper-text">
            Перетащите комплектующие из меню внутрь шкафа
        </div>
    </div>
</template>

<script>
import SVGDND from '@/UI/SVG/SVGDND.vue';

export default {
    name: 'ContextHelperDND',
    components: { SVGDND },
};
</script>

<style scoped lang="scss">
@import "CSS/lowerHelpers";;
</style>
